export default __webpack_public_path__ + "static/media/Location.c0f93bd5.svg";